const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Resolve image paths — handles both relative /api/ paths and full URLs
 */
export function resolveImageUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/api/')) return `${API_BASE}${path}`;
  return path;
}
